import { PaymentBannerModal } from './PaymentBannerModal';

export default PaymentBannerModal;
